import { BaseOperation } from 'src/app/perical/models/thermal-operation.model';

export enum WellheadType {
  Conventional = 'conventional',
  MultiBowl = 'multiBowl'
}

export enum HangerLandingSequence {
  BeforeCementSet = 'beforeCementSet',
  AfterCementSet = 'afterCementSet'
}

export interface WellheadDto {
  stringMountedOn: string;
  pointOfFixityMeasuredDepth: number | null;
  landedOnBasePlateInitialGap: number | null;
  lockDownForceLimit: number | null;
  wellheadType: WellheadType;
}

export interface TubularLandingDto {
  tubularStringRef: string;
  hangerLandingSequence: HangerLandingSequence;
  nippleDownPreviousBop: boolean;
  nippleUpWellheadSectionWeight: number | null;
  lockRingRating: number | null;
  nippleUpBopWeight: number | null;
  nippleUpXmasTreeWeight: number | null;
  loadCompensatorAppliedLoad: number | null;
  initialConditionPericalOperationId: string | null;
}

export interface UpdateWellheadMovementInputsModel {
  wellhead: WellheadDto;
  tubularLandings: TubularLandingDto[];
  finalConditionPericalOperationId: string | null;
}

export type WellheadMovementResponseDto = Partial<UpdateWellheadMovementInputsModel>;

export class StringLanding {
  public tubularStringId = '';
  public name = '';
  public nippleDownPreviousBOP = true;
  public hangerLandingSequence: HangerLandingSequence = HangerLandingSequence.BeforeCementSet;
  public nippleUpWellheadOrWellheadSection = true;
  public wellheadSectionWeight = 100000;
  public hasLockRingRating = false;
  public lockRingRating = 100000;
  public nippleUpBOP = true;
  public bopWeight = 100000;
  public nippleUpXmasTree = true;
  public treeWeight = 100000;
  public loadCompensator = true;
  public appliedLoad = 100000;
  public initialTemperature: Partial<BaseOperation> | null = null;

  public constructor(init?: Partial<StringLanding>) {
    Object.assign(this, init);
  }
}

export class WellheadData {
  public wellheadMountedOn = '';
  public landBasePlateOnNextOuterCasingString = true;
  public initialGapAboveBasePlate = 0;
  public hasLockdownForceLimit = false;
  public lockdownForceLimit = 100000;
  public wellheadType: WellheadType = WellheadType.Conventional;
  public pointOfFixityIsAutomatic = true;
  public pointOfFixity = 150;
  public finalOperation: Partial<BaseOperation> | null = null;
  public stringLandings: StringLanding[] = [];

  public constructor(init?: Partial<WellheadData>) {
    Object.assign(this, init);
    if (typeof this.finalOperation === 'string') {
      this.finalOperation = { id: this.finalOperation, name: this.finalOperation };
    }
  }
}
